module.exports = __webpack_public_path__ + "img/pill-dimensions-intro.88e31618.svg";